import * as React from 'react'

import { apiJson } from '@/lib/api'
import type { StoryboardListResponse, StoryboardSummary } from '@/types'

/**
 * Fetches the caller's storyboards (newest first) for the Library's
 * Storyboards tab. Task 4. Returns the same `loading / refresh` shape as
 * useAllAssets so the UI patterns stay consistent across tabs.
 */
export function useStoryboards(): {
  items: StoryboardSummary[]
  loading: boolean
  error: string | null
  refresh: () => Promise<void>
} {
  const [items, setItems] = React.useState<StoryboardSummary[]>([])
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)

  const load = React.useCallback(async () => {
    setLoading(true)
    try {
      const data = await apiJson<StoryboardListResponse>('/api/v1/storyboards?limit=100')
      setItems(data.items || [])
      setError(null)
    } catch (err) {
      setError((err as Error).message)
    } finally {
      setLoading(false)
    }
  }, [])

  React.useEffect(() => {
    load()
  }, [load])

  return { items, loading, error, refresh: load }
}
